import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const getCountryProgramEligibilityRules: (
  fetchContext: FetchContext, 
  programId: number, 
  countryId: number, 
  accessToken?: string) => Promise<string[]> = (fetchContext, programId, countryId, accessToken) =>
  fetch(`${fetchContext.baseUrl}/api/staff/programs/${programId}/countries/${countryId}/eligibility-rules`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  }).then((response) => responseErrorHandler<string[]>(fetchContext.errorStore, response, 'get country program eligibility rules'));
